import { render, staticRenderFns } from "./ImpressaoAnamnese.vue?vue&type=template&id=54358fad&"
import script from "./ImpressaoAnamnese.vue?vue&type=script&lang=js&"
export * from "./ImpressaoAnamnese.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports